'use strict';

var reactUtils = require('@sravni/react-utils');
var colors = require('../../../constants/colors.js');

reactUtils.tuple('divider', 'space');
reactUtils.tuple(colors.COLORS.LIGHT);
//# sourceMappingURL=Accordion.types.js.map
